export default "<div class=\"sophia-app\">\r\n    <ngx-spinner></ngx-spinner>\r\n\r\n<router-outlet></router-outlet>\r\n</div>\r\n"